<div class="page-container" [testId]="'report-list-container'">
  <div class="search-section" [testId]="'search-section'">
    <div nz-row [nzGutter]="24" class="search-row" [testId]="'search-row'">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="search-input-container" [testId]="'search-input-container'">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'report.search-placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'search-input'"
          />
          <ng-template #suffixIconSearch [testId]="'search-icon-template'">
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'report.search-tooltip' | i18n"
              [testId]="'search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          nz-button
          nzType="default"
          (click)="reset()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'common.reset' | i18n"
          [testId]="'reset-button'"
        >
          <i nz-icon nzType="clear" [testId]="'reset-icon'"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- 可滚动的内容区域 -->
  <div class="table-section">
    <nz-table
      #basicTable
      class="content-table"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="loading"
      [testId]="'report-table'"
    >
      <thead [testId]="'report-table-head'">
        <tr [testId]="'report-table-head-row'">
          <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" [testId]="'report-table-head-serial'">{{
            'common.serial-number' | i18n
          }}</th>
          <th scope="col" [nzWidth]="'100px'" [testId]="'report-table-head-reporter'">{{ 'report.table.reporter' | i18n }}</th>
          <th scope="col" [nzWidth]="'100px'" [testId]="'report-table-head-target'">{{ 'report.table.reported-object' | i18n }}</th>
          <th scope="col" [nzWidth]="'120px'" [testId]="'report-table-head-target-type'">{{ 'report.table.object-type' | i18n }}</th>
          <th scope="col" [nzWidth]="'150px'" [testId]="'report-table-head-report-type'">{{ 'report.table.report-type' | i18n }}</th>
          <th scope="col" [nzWidth]="'200px'" [testId]="'report-table-head-content'">{{ 'report.table.content' | i18n }}</th>
          <th scope="col" [nzWidth]="'180px'" [testId]="'report-table-head-time'">{{ 'report.table.report-time' | i18n }}</th>
          <th scope="col" [nzWidth]="'100px'" [testId]="'report-table-head-status'">{{ 'common.status' | i18n }}</th>
          <th scope="col" [nzWidth]="'100px'" [testId]="'report-table-head-handler'">{{ 'report.table.processor' | i18n }}</th>
          <th scope="col" [nzWidth]="'150px'" [testId]="'report-table-head-result'">{{ 'report.table.result' | i18n }}</th>
          <th scope="col" [nzWidth]="'100px'" [testId]="'report-table-head-source'">{{ 'report.table.source' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'report-table-body'">
        <tr *ngFor="let item of listOfData; let i = index" [testId]="'report-table-row-' + i">
          <td nzLeft class="text-center row-number-column" [testId]="'report-table-cell-serial-' + i">{{ i + 1 }}</td>
          <td [testId]="'report-table-cell-reporter-' + i">{{ getNameOrId(item.accountName, item.accountId) }}</td>
          <td [testId]="'report-table-cell-target-' + i">{{ getNameOrId(item.objectName, item.objectId) }}</td>
          <td [testId]="'report-table-cell-target-type-' + i">
            <nz-tag [nzColor]="getObjectTypeColor(item.objectType)" [testId]="'report-table-type-tag-' + i">{{
              getObjectTypeText(item.objectType)
            }}</nz-tag>
          </td>
          <td [testId]="'report-table-cell-report-type-' + i"
            ><span class="content-cell" nz-tooltip [nzTooltipTitle]="item.type" [testId]="'report-table-type-span-' + i">{{
              item.type
            }}</span></td
          >
          <td [testId]="'report-table-cell-content-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.content" [testId]="'report-table-content-span-' + i">{{
              item.content
            }}</span>
          </td>
          <td [testId]="'report-table-cell-time-' + i">{{ item.createTime | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}</td>
          <td [testId]="'report-table-cell-status-' + i">
            <nz-tag [nzColor]="getStatusColor(item.status)" [testId]="'report-table-status-tag-' + i">{{
              getStatusText(item.status)
            }}</nz-tag>
          </td>
          <td [testId]="'report-table-cell-handler-' + i">{{ getNameOrId(item.processorName, item.processorId) }}</td>
          <td [testId]="'report-table-cell-result-' + i">
            <span class="content-cell" nz-tooltip [nzTooltipTitle]="item.result" [testId]="'report-table-result-span-' + i">{{
              item.result ?? '-'
            }}</span>
          </td>
          <td [testId]="'report-table-cell-source-' + i">{{ item.channel ?? '-' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div class="pagination-section" *ngIf="total > 0" [testId]="'pagination-section'">
    <div class="pagination-info" [testId]="'pagination-info'">{{ 'common.total-records' | i18n: { total: total } }}</div>
    <div class="pagination-controls" [testId]="'pagination-controls'">
      <nz-pagination
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        [testId]="'pagination'"
      />
    </div>
  </div>
</div>
